export const messages = {
  ko: require("./ko").default,
  en: require("./en").default,
  es: require("./es").default,
  "es-ES": require("./es-ES").default,
  fr: require("./fr").default,
  it: require("./it").default,
  pt: require("./pt").default,
  ru: require("./ru").default,
  bs: require("./bs").default,
  de: require("./de").default,
  et: require("./et").default,
  hr: require("./hr").default,
  hu: require("./hu").default,
  lt: require("./lt").default,
  lv: require("./lv").default,
  mk: require("./mk").default,
  ro: require("./ro").default,
  sl: require("./sl").default,
  sq: require("./sq").default,
  sr: require("./sr").default,
  bg: require("./bg").default,
  sv: require("./sv").default,
  pl: require("./pl").default,
  fi: require("./fi").default,
  da: require("./da").default,
  no: require("./no").default,
  vi: require("./vi").default,
  "uk-UA": require("./uk-UA").default,
  "cs": require("./cs").default,
  "sk": require("./sk").default,
  "gr": require("./gr").default,
  "zh-CN": require("./zh-CN").default,
  "zh-HK": require("./zh-HK").default,
  "zh-TW": require("./zh-TW").defaults
};
